<template>
  <div id="app">
    <div class="header-top">
      <div class="header">
        <div class="logo_img" @click="logoClick">
          <div
            style="
              display: flex;
              align-items: center;
              float: left;
              height: 65px;
            "
          >
            <div class="header-logo">
              <img id="header-img" src="./assets/logo.png" />
            </div>
          </div>
          <div style="display: flex; float: left; height: 65px">
            <div class="header-important">
              <div class="company_name">水母物联</div>
              <!-- <div class="header-title company_name">www.wbihua.com</div> -->
            </div>
          </div>
        </div>
        <div class="nav">
          <!-- <div @click="handleSelectMobile('2')">产品介绍</div> -->
          <div @click="handleSelectMobile('3')">联系我们</div>
          <div @click="handleSelectMobile('4')">公司介绍</div>
          <div @click="handleSelectMobile('6')">商城</div>
        </div>
        <!-- <div id="menu_index">
          <el-menu
            v-if="seen"
            :default-active="activeIndex"
            class="el-menu-demo"
            menu-trigger="click"
            text-color="#333"
            style="height: 65px; border: 0"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="1" class="header-title">首页</el-menu-item>
            <el-menu-item index="2" class="header-title"
              >产品解决方案</el-menu-item
            >
            <el-menu-item index="3" class="header-title"
              >微信商城平台</el-menu-item
            >
            <el-menu-item index="4" class="header-title"
              >微信公众号管理平台</el-menu-item
            >
            <el-menu-item index="5" class="header-title">合作伙伴</el-menu-item>
            <el-menu-item index="6" class="header-title">关于我们</el-menu-item>
          </el-menu>
          

          <el-menu
            v-if="!seen"
            :default-active="activeIndex"
            class="el-menu-demo"
            menu-trigger="click"
            text-color="#333"
            style="height: 65px; border: 0"
            mode="horizontal"
            @select="handleSelectMobile"
          >
            <el-sub-menu index="1" class="header-title mobile_menu">
              <template #title>{{ currentMenu }}</template>
              <el-menu-item index="1" class="header-title">首页</el-menu-item>
              <el-menu-item index="2" class="header-title"
                >产品解决方案</el-menu-item
              >
              <el-menu-item index="3" class="header-title"
                >微信商城平台</el-menu-item
              >
              <el-menu-item index="4" class="header-title"
                >微信公众号管理平台</el-menu-item
              >
              <el-menu-item index="5" class="header-title"
                >合作伙伴</el-menu-item
              >
              <el-menu-item index="6" class="header-title"
                >关于我们</el-menu-item
              >
            </el-sub-menu>
          </el-menu>
        </div> -->
      </div>
    </div>
    <div class="container" style="clear: both" >
      <router-view></router-view>
    </div>

    <div style="width: 100%; background-color: #050f19; padding: 40px 0">
      <div style="max-width: 1440px; margin: 0 auto">
        <!-- <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <p class="footer_font">邮箱：njbihua@163.com</p>
            <div style="margin: auto" class="footer_font">
              互联网ICP备案：
              <a href="http://beian.miit.gov.cn/" target="_blank"
                >苏ICP备2023011730号-1</a
              >
            </div>
            <div style="margin: auto" class="footer_font">
              www.wbihua.com 南京碧华科技有限公司版权所有
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div>
              <img
                :src="company.qrcode"
                style="width: 100px; height: 100px; border: 0"
              />
            </div>
            <div class="footer_font">关注南京碧华商务公众号</div>
          </el-col>
        </el-row> -->
        <div class="foot">
          <div class="foot-let">
            <div class="content">
              <div class="li-1">商务合作</div>
              <div class="li-2">13911299113</div>
              <div class="li-3">邮编：518112</div>
            </div>
            <div class="content">
              <div class="li-1">联系客服</div>
              <div class="li-2">15323733119</div>
              <div class="li-3">邮编：518112</div>
            </div>
          </div>
          <div class="foot-ret">
            <div class="wrap">
              <img src="../static/other/QRcode1.jpg" alt="" />
              <div>水母物联公众号</div>
            </div>
            <div class="wrap">
              <img src="../static/other/QRcode2.jpg" alt="" />
              <div>水母物联小程序</div>
            </div>
          </div>
        </div>
        <div style="width: 100%; margin: 24px auto">
          <div style="height: 1px; padding: 0; background-color: #293a49"></div>
        </div>
        <div
          style="
            font-size: 12px;
            width: 100%;
            margin: 12px auto;
            text-align: center;
            color: #748ea6;
          "
        >
          地址：深圳市龙岗区宝龙街道宝龙社区南同大道28号贝斯达医疗器械大厦1栋B号厂房1B301
        </div>
        <div
          style="
            font-size: 12px;
            width: 100%;
            margin: 12px auto 0;
            text-align: center;
            color: #748ea6;
          "
        >
          Copyright Ⓒ2025 深圳水母物联安全技术有限公司版权所有
          <a
            href="http://beian.miit.gov.cn/"
            target="_blank"
            style="color: #68aeef"
            >粤ICP备2024314374号</a
          >
        </div>
        <div
          style="
            font-size: 12px;
            width: 100%;
            margin: 12px auto;
            text-align: center;
            color: #68aeef;
            cursor: pointer;
          "
        >
          <span @click="$router.push({ name: 'privacyPolicy' })"
            >《隐私协议》</span
          ><span @click="$router.push({ name: 'userAgreement' })"
            >《服务协议》</span
          >
        </div>
      </div>
    </div>
    <div id="back_to_top" ref="btn" @click="backTop">
      <!-- <p style="font-size: 0.625em; font-weight: bold">TOP</p> -->
      <img src="./assets/other/launch.png" style="height: 45px; width: 35px" />
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  name: "App",
  setup() {
    let btn = ref(null); //本质是reactive({value:null})
    // 需要在生命周期获取
    //onMounted(()=>{
    // 当界面挂载出来后就会自动执行
    //console.log(btn.value);
    //});
    //接受的是null,原因是setup执行时机比mounted早,dom还没形成
    //console.log(btn.value);
    return { btn };
  },
  data() {
    return {
      activeIndex: "1",
      company: {
        qrcode: require("../static/other/qrcode.jpg"),
      },
      scroll: "",
      timer: "",
      seen: true,
      currentMenu: "首页",
    };
  },
  methods: {
    handleSelect(key) {
      switch (key) {
        case "1":
          this.$router.push({ name: "Index" });
          break;
        case "2":
          this.$router.push({ name: "Index" });
          window.location.hash = "#产品解决方案";
          break;
        case "3":
          this.$router.push({ name: "Index" });
          window.location.hash = "#微信商城平台";
          break;
        case "4":
          this.$router.push({ name: "Index" });
          window.location.hash = "#微信公众号管理平台";
          break;
        case "5":
          this.$router.push({ name: "Index" });
          window.location.hash = "#合作伙伴";
          break;
        case "6":
          this.$router.push({ name: "Index" });
          window.location.hash = "#关于我们";
          break;
      }
    },
    handleSelectMobile(key) {
      switch (key) {
        case "1":
          this.$router.push({ name: "Index" });
          this.currentMenu = "首页";
          break;
        case "2":
          this.$router.push({ name: "Index" });
          window.location.hash = "#产品介绍";
          // this.currentMenu = "首页";
          break;
        case "3":
          this.$router.push({ name: "Index" });
          window.location.hash = "#联系我们";
          break;
        case "4":
          this.$router.push({ name: "Index" });
          window.location.hash = "#公司介绍";
          break;
        case "5":
          this.$router.push({ name: "Index" });
          window.location.hash = "#合作伙伴";
          this.currentMenu = "首页";
          break;
        case "6":
        this.$router.push({
        path: `/ShoppingPage`,
      });
          // this.$router.push({ name: "Index" });
          // window.location.hash = "#关于我们";
          break;
      }
    },
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
      if (this.scroll > 600) {
        //判断滚动后高度超过400px,就显示
        this.btn.style.display = "block";
      } else {
        this.btn.style.display = "none";
      }
    },
    backTop() {
      //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
      this.timer = setInterval(() => {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(this.timer);
        }
      }, 30);
    },
    menuSeen() {
      // 屏幕尺寸
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 430) {
        this.seen = true;
      } else {
        this.seen = false;
      }
    },
    logoClick() {
      this.$router.push({ name: "Index" });
      this.currentMenu = "首页";
    },
  },
  mounted() {
    this.menuSeen();
    // window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" >
ui {
  list-style: none;
}
li {
  list-style: none;
}
#app {
  background: #fafafa;
}
.logo_img {
  float: left;
  width: 40%;
  cursor: pointer;
}
.nav {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;
  div {
    margin-right: 80px;
    cursor: pointer;
  }
}
#back_to_top {
  position: fixed;
  bottom: 50px;
  right: 30px;
  z-index: 200;
  cursor: pointer;
}

.header-title {
  font-size: 1em;
}

.company_name {
  color: #fff;
  font-size: 1.1em;
  font-weight: 500;
}

.footer_font {
  font-size: 1em;
}

#menu_index {
  float: left;
  width: 70%;
  height: 100%;

  .el-menu-demo {
    background: #000;
  }
}

.header-top {
  width: 100%;
  background: #000;
  .header {
    margin: auto;
    width: 90%;
    height: 65px;
  }
}
.foot {
  // width: 100%;
  margin: 0 120px;
  display: flex;
  // justify-content: space-between;
  .foot-let {
    display: flex;
    // flex: 0 0 60%;
    width: 60%;
    .content {
      margin-right: 130px;
      color: #fff;
      font-weight: 500;
      .li-1 {
        font-size: 18px;
        margin-bottom: 16px;
      }
      .li-2 {
        font-size: 24px;
      }
      .li-3 {
        font-size: 14px;
        color: #748ea6;
      }
    }
  }
  .foot-ret {
    // flex: 1;
    width: 40%;
    display: flex;
    justify-content: center;
    .wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 50px;
      img {
        width: 108px;
        height: 108px;
        margin-bottom: 12px;
      }
      div {
        font-size: 14px;
        color: #748ea6;
      }
    }
  }
}

@media screen and (max-device-width: 430px) {
  .logo_img {
    float: left;
    width: auto;
    cursor: pointer;
  }
  .nav {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    color: #fff;
    font-size: 14px;
    div {
      margin-right: 0;
      cursor: pointer;
    }
  }
  #back_to_top {
    position: fixed;
    bottom: 50px;
    right: 5px;
    z-index: 200;
    cursor: pointer;
  }

  .footer_font {
    font-size: 0.875em;
  }

  #menu_index {
    float: right;
    width: auto;
    height: 100%;
  }

  .mobile_menu {
  }
  .header-important {
    display: none;
  }

  .foot {
    // width: 100%;
    margin: 0;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    .foot-let {
      display: flex;
      // flex: 0 0 60%;
      width: 100%;
      justify-content: center;
      margin-bottom: 30px;
      .content {
        display: flex;
        flex-direction: column;
        margin-right: 10px;
        align-items: center;
        margin-left: 6px;
        .li-1 {
          font-size: 14px;
          margin-bottom: 16px;
        }
        .li-2 {
          font-size: 16px;
        }
        .li-3 {
          font-size: 12px;
          color: #748ea6;
        }
      }
    }
    .foot-ret {
      // flex: 1;
      width: 100%;
      display: flex;
      justify-content: center;
      .wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 10px;
        img {
          width: 108px;
          height: 108px;
          margin-bottom: 12px;
        }
        div {
          font-size: 14px;
          color: #748ea6;
        }
      }
    }
  }
}

#header-img {
  width: 28px;
  height: 42px;
  float: left;
  margin: auto;
}

.header-logo {
  width: 28px;
  height: 42px;
  align-self: center;
}

.header-important {
  float: left;
  margin-left: 6px;
  align-self: center;
}

.footer {
  display: flex;
  align-items: center;
  margin: 10px auto;
  width: 90%;
}

a {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}

</style>